module.exports = __webpack_public_path__ + "static/media/ageelementantiwrinklenightcream.16dfd84f.png";